import React from "react";
import StyledHome from "../../../utils/styles/StyledHome";
import SungOne from "../assets/Sung-Icon-1.svg";
import SungTwo from "../assets/Sung-Icon-2.svg";
import SungThree from "../assets/US-Army.svg";
import SungFour from "../assets/Ranger.svg";
import { ReactSVG } from "react-svg";
import styled from "styled-components";
import { StyledSung } from "../styles";
import { motion } from "framer-motion";
import SungBG from "../assets/SungImage@2x.png";
import BGImageDisplay from "../../../Components/BGImageDisplay/BGImageDisplay";
// import Under from "./assets/30under30.svg";
// import Entrepreneur from "./assets/Entrepreneur.svg";

const variants = {
  visible: (i) => ({
    x: i.x,
    y: i.y,
    opacity: 1,
    transition: { duration: 1 },
  }),
};

const SungStyles = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: calc(100vh - 100px);
  z-index: 3;
  font-size: 36px;
  align-items: flex-end;
  color: white;
  justify-content: flex-end;

  span {
    font-family: lato;
    margin-bottom: 12px;
    margin-right: 20px;
  }
`;

const Leadership = () => {
  return (
    <>
      <SungStyles>
        <span> Sung Lee, CFO</span>
      </SungStyles>
      <StyledSung>
        <motion.div
          initial={{ x: 340, y: 320, opacity: 0 }}
          custom={{ x: 340, y: 360, num: 1 }}
          animate="visible"
          variants={variants}
        >
          <ReactSVG
            src={SungOne}
            beforeInjection={(svg) => {
              svg.classList.add("sungIcon");
            }}
          />
        </motion.div>
        <motion.div
          initial={{ x: 110, y: 235, opacity: 0 }}
          custom={{ x: 110, y: 275, num: 2 }}
          animate="visible"
          variants={variants}
        >
          <ReactSVG
            src={SungTwo}
            beforeInjection={(svg) => {
              svg.classList.add("sungIcon");
            }}
          />
        </motion.div>
        <motion.div
          initial={{ x: 340, y: -190, opacity: 0 }}
          custom={{ x: 340, y: -150, num: 3 }}
          animate="visible"
          variants={variants}
        >
          <ReactSVG
            src={SungThree}
            beforeInjection={(svg) => {
              svg.classList.add("sungIcon");
            }}
          />
        </motion.div>
        <motion.div
          initial={{ x: 110, y: -260, opacity: 0 }}
          custom={{ x: 110, y: -220, num: 4 }}
          animate="visible"
          variants={variants}
        >
          <ReactSVG
            src={SungFour}
            beforeInjection={(svg) => {
              svg.classList.add("sungIcon");
            }}
          />
        </motion.div>
      </StyledSung>
      <StyledHome>
        <BGImageDisplay
          bgimage={SungBG}
          options={{
            height: "100%",
            objpos: "94%",
          }}
        ></BGImageDisplay>
        {/* <Image
          onClick={(e) => e.preventDefault()}
          className="background-image"
          cloudName="dqmi6odzk"
          publicId="digital_demo/Sung.png"
        /> */}
      </StyledHome>
    </>
  );
};

export default Leadership;
